"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var router_1 = require("@angular/router");
var branch_service_1 = require("../../../shared/service/branch.service");
var find_http_error_1 = require("../../../shared/error/find-http-error");
var actions_1 = require("../../../core/actions");
var store_1 = require("@angular-redux/store");
var toast_service_1 = require("../../../shared/service/toast.service");
var BranchListComponent = /** @class */ (function () {
    function BranchListComponent(_branchService, _router, _ngRedux, _toastService) {
        this._branchService = _branchService;
        this._router = _router;
        this._ngRedux = _ngRedux;
        this._toastService = _toastService;
        this.pageNumber = 0;
        this.pageSize = 15;
        this.nextDisabled = false;
        this.filterField = ['branchFilter'];
        this.nameFilter = ['name'];
        this.customerNameFilter = ['customerName'];
        this.cityFilter = ['city'];
        this.stateFilter = ['state'];
        this.osFilter = ['os'];
        this.jiraTicketFilter = ['jiraTicket'];
        this.invoiceNumberFilter = ['invoiceNumber'];
        this.filter = [];
        this.filterIsOpened = false;
        this.filterLabel = '';
        this.filterActionType = actions_1.UPDATE_BRANCH_FILTER;
        this.inputTypeFilter = 'text';
        this.branches = new Array();
        this.findBranches();
        this.setUpObservers();
    }
    BranchListComponent.prototype.ngOnInit = function () {
    };
    BranchListComponent.prototype.newBranch = function () {
        this._router.navigate(["branches"]);
    };
    BranchListComponent.prototype.editBranch = function (id) {
        this._router.navigate(["branches/" + id]);
    };
    BranchListComponent.prototype.deleteBranch = function (id) { };
    BranchListComponent.prototype.findBranches = function () {
        this._branchService.findBranches(this.pageNumber, this.pageSize);
    };
    BranchListComponent.prototype.findByFilter = function () {
        this.pageNumber = 0;
        this.filterIsOpened = false;
        this.findBranches();
    };
    BranchListComponent.prototype.openFilter = function (inputType, label, filterField) {
        if (filterField[filterField.length - 1] === this.filter[this.filter.length - 1] && this.filterIsOpened) {
            this.filterIsOpened = false;
        }
        else {
            this.filter = this.filterField.concat(filterField);
            this.filterIsOpened = true;
            this.inputTypeFilter = inputType;
            this.filterLabel = label;
        }
    };
    BranchListComponent.prototype.goToPage = function (pageNumber) {
        this.pageNumber = pageNumber > 0 ? pageNumber - 1 : pageNumber;
        this.findBranches();
    };
    BranchListComponent.prototype.previousPage = function () {
        if (this.pageNumber > 0) {
            this.pageNumber = this.pageNumber - 1;
            this.findBranches();
        }
    };
    BranchListComponent.prototype.nextPage = function () {
        if (this.pageNumber < this.pageInfo.lastPage - 1) {
            this.pageNumber = this.pageNumber + 1;
            this.findBranches();
        }
    };
    BranchListComponent.prototype.setUpObservers = function () {
        this.branchFilter$ = this._ngRedux.select('branchFilter');
        this.setUpFindAction(this._branchService.find$);
        this.setUpErrorAction(this._branchService.error$);
        this.setUpPageInfo(this._branchService.pageInfo$);
    };
    BranchListComponent.prototype.setUpFindAction = function (observable) {
        var _this = this;
        observable
            .filter(function (branches) { return branches instanceof Array; })
            .subscribe(function (branches) {
            _this.branches = branches;
        });
    };
    BranchListComponent.prototype.setUpErrorAction = function (observable) {
        var _this = this;
        observable
            .filter(function (error) { return error instanceof find_http_error_1.FindHttpError; })
            .subscribe(function (error) {
            _this.showMessage(error.text);
        });
    };
    BranchListComponent.prototype.setUpPageInfo = function (observable) {
        var _this = this;
        observable
            .subscribe(function (pageInfo) { return _this.pageInfo = pageInfo; });
    };
    BranchListComponent.prototype.showMessage = function (message) {
        this._toastService.showMessage(message, 4000);
    };
    BranchListComponent.ctorParameters = function () { return [{ type: branch_service_1.BranchService }, { type: router_1.Router }, { type: store_1.NgRedux }, { type: toast_service_1.ToastService }]; };
    return BranchListComponent;
}());
exports.BranchListComponent = BranchListComponent;
//# sourceMappingURL=branch-list.component.js.map


// WEBPACK FOOTER //
// branch-list.component.js